import React from 'react';

import { LegacyBox, Link, LegacyText } from '@gogame/components';
import { useProcessAsync } from '@gogame/hooks-ts';
import { useScreenState } from '@gogame/screens';

import { useLoadTemplate } from 'scenes/BulkUpload/hooks';

export default () => {
  const screenState = useScreenState();
  const [loading, loadingWrapper] = useProcessAsync();
  const loadTemplate = useLoadTemplate(loadingWrapper);

  const handleLoadTemplate = async () => {
    await loadTemplate({ partner: screenState.partner });
  };

  return (
    <LegacyBox align={'center'} justifyContent={'center'}>
      <LegacyText>
        <Link onClick={handleLoadTemplate} disabled={loading}>
          Export {screenState.partner} template
        </Link>
      </LegacyText>
    </LegacyBox>
  );
};
